// src/redux/reducer.js
const initialState = {
    formLink: '',
  };
  
  const formReducer = (state = initialState, action) => {
    switch (action.type) {
      case 'SAVE_FORM_LINK':
        return {
          ...state,
          formLink: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default formReducer;